import React, { useEffect, useState } from 'react';
import { AmountField } from '@octane/spark';
import PropTypes from "prop-types";

import {
  StyledSlider,
  Track,
  Thumb,
  Container,
  Header,
  Label,
} from './slider-amounts.styles';

import {ReactComponent as IconRange} from '../../icons/range.svg'

const SliderAmount = ({
  label,
  min = 0,
  max,
  value,
  step = 100,
  onChange,
  fill,
}) => {
   const safeValue = typeof value === 'number' ? value : min ?? 0;
   const [inputValue, setInputValue] = useState(safeValue.toString());

  useEffect(() => {
   if (typeof value === 'number') {
      setInputValue(value.toString());
   }
  }, [value]);

  const handleChangeInput = (values) => {
    const raw = values.value;
    setInputValue(raw);
  };

  const handleBlur = () => {
   const cleaned = inputValue.replace(/[^\d.eE+-]/g, '');
   const parsed = Number(cleaned);

   if (isNaN(parsed)) {
     const fallback = Math.max(min, 0);
     setInputValue(fallback.toString());
     onChange(fallback);
   } else {
     const corrected = Math.min(Math.max(Math.floor(parsed), min), max);
     setInputValue(corrected.toString());
     onChange(corrected);
   }
 };

  const handleChangeSlider = (val) => {
    const clamped = Math.min(Math.max(val, min), max);
    setInputValue(clamped.toString());
    onChange(clamped);
  };

  return (
    <Container>
      <Header>
        <Label>{label}</Label>
        <AmountField
          value={inputValue}
          onChange={handleChangeInput}
          onBlur={handleBlur}
          min={min}
          max={max}
          omitDecimals
        />
      </Header>
      <StyledSlider
        value={Number(inputValue || value.toString(), 10)}
        min={min}
        max={max}
        step={step}
        renderTrack={(props, state) => {
          const { as: _as, key, ...restProps } = props;
          return <Track {...restProps} key={key} activeTrack={state.index === 0} />;
        }}
        renderThumb={(props) => (
          <Thumb {...props} key={props.key} as="div">
            <IconRange fill={fill ? fill : '#005EB8'}/>
          </Thumb>
        )}
        onChange={handleChangeSlider}
      />
    </Container>
  );
};

SliderAmount.propTypes = {
   fill: PropTypes.string,
};

export default SliderAmount;
